import * as TYPES from './mutations-types'

export default {
  [TYPES.SET_COMMENTS_LIST] (state, loadedList) {
    state.commentsList = loadedList
  }
}
